(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pottery-styles"] && !Shopify.designMode) return;
  try {
    function clampPotteryQuantity(input) {
    if (!input.max) return;
    const maximum = Number(input.max);
    if (Number(input.value) > maximum) input.value = maximum;
  }

  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-inventory-quantity]')) return;
    clampPotteryQuantity(event.target);
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-cart-quantity]')) {
      const form = event.target.form;
      const updateButton = form?.querySelector('[name="update"]');
      if (form && updateButton) form.requestSubmit(updateButton);
      return;
    }
    if (!event.target.matches('[data-pottery-variant]')) return;
    const quantity = event.target.closest('form').querySelector('[data-inventory-quantity]');
    const maximum = event.target.selectedOptions[0].dataset.maxQuantity;
    if (maximum && Number(maximum) > 0) quantity.max = maximum;
    else quantity.removeAttribute('max');
    clampPotteryQuantity(quantity);
  });
  } catch(e) { console.error(e); }
})();

})();
